export const nfseWebhookErrorMappings1 = {
    NFSE_WEBHOOK_PREFEITURA_CONNECTION_ERROR: {
        code: 'NFSE_WEBHOOK_PREFEITURA_CONNECTION_ERROR',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'Não foi possível conectar ao serviço da prefeitura. Tente novamente em alguns instantes.',
            },
            {
                language: 'pt-BR',
                message: 'Não foi possível conectar ao serviço da prefeitura. Tente novamente em alguns instantes.',
            },
            {
                language: 'en-US',
                message: 'Unable to connect to the city hall service. Please try again in a few moments.',
            },
            {
                language: 'es-ES',
                message: 'No fue posible conectar al servicio de la alcaldía. Intente nuevamente en unos momentos.',
            },
        ],
        technicalMessage: 'O webservice da prefeitura retornou erro de conexao com o servidor',
        severity: 'error',
        critical: false,
    },
    NFSE_WEBHOOK_INVALID_TAXATION_CODE: {
        code: 'NFSE_WEBHOOK_INVALID_TAXATION_CODE',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'O código de tributação informado é inválido. O valor deve ser numérico. Verifique o código nas configurações de nota fiscal.',
            },
            {
                language: 'pt-BR',
                message: 'O código de tributação informado é inválido. O valor deve ser numérico. Verifique o código nas configurações de nota fiscal.',
            },
            {
                language: 'en-US',
                message: 'The provided taxation code is invalid. The value must be numeric. Please check the code in the invoice settings.',
            },
            {
                language: 'es-ES',
                message: 'El código de tributación informado es inválido. El valor debe ser numérico. Verifique el código en la configuración de facturas.',
            },
        ],
        technicalMessage: 'Valor inválido para o campo Codigo Tributacao',
        severity: 'error',
        critical: false,
    },
    NFSE_WEBHOOK_INVALID_SERIES_VALUE: {
        code: 'NFSE_WEBHOOK_INVALID_SERIES_VALUE',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'O campo série deve conter apenas números. Verifique as configurações de RPS.',
            },
            {
                language: 'pt-BR',
                message: 'O campo série deve conter apenas números. Verifique as configurações de RPS.',
            },
            {
                language: 'en-US',
                message: 'The series field must contain only numbers. Please check the RPS settings.',
            },
            {
                language: 'es-ES',
                message: 'El campo serie debe contener solo números. Verifique la configuración de RPS.',
            },
        ],
        technicalMessage: 'Valor inválido para o campo serie, deve ser um numero',
        severity: 'error',
        critical: false,
    },
    NFSE_WEBHOOK_INVALID_REGIME_ESPECIAL_TRIBUTACAO: {
        code: 'NFSE_WEBHOOK_INVALID_REGIME_ESPECIAL_TRIBUTACAO',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'Regime especial de tributação inválido. Os valores aceitos são 1, 2, 3, 4, 5, 6 e 7. Verifique as configurações de nota fiscal.',
            },
            {
                language: 'pt-BR',
                message: 'Regime especial de tributação inválido. Os valores aceitos são 1, 2, 3, 4, 5, 6 e 7. Verifique as configurações de nota fiscal.',
            },
            {
                language: 'en-US',
                message: 'Invalid special tax regime. Accepted values are 1, 2, 3, 4, 5, 6 and 7. Please check the invoice settings.',
            },
            {
                language: 'es-ES',
                message: 'Régimen especial de tributación inválido. Los valores aceptados son 1, 2, 3, 4, 5, 6 y 7. Verifique la configuración de facturas.',
            },
        ],
        technicalMessage: 'Valor inválido para o campo RegimeEspecialTributacao',
        severity: 'error',
        critical: false,
    },
    NFSE_WEBHOOK_INVALID_ITEM_LIST_SERVICE_CODE: {
        code: 'NFSE_WEBHOOK_INVALID_ITEM_LIST_SERVICE_CODE',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'O código do item da lista de serviços é obrigatório e deve ter no máximo 5 caracteres. Informe um item da LC 116 (3 ou 4 dígitos) ou da Tabela de Serviços da Portaria SF Nº 72/2006 de São Paulo (5 dígitos).',
            },
            {
                language: 'pt-BR',
                message: 'O código do item da lista de serviços é obrigatório e deve ter no máximo 5 caracteres. Informe um item da LC 116 (3 ou 4 dígitos) ou da Tabela de Serviços da Portaria SF Nº 72/2006 de São Paulo (5 dígitos).',
            },
            {
                language: 'en-US',
                message: 'The service list item code is required and must have at most 5 characters. Enter an item from LC 116 (3 or 4 digits) or from the São Paulo SF Ordinance No. 72/2006 Service Table (5 digits).',
            },
            {
                language: 'es-ES',
                message: 'El código de ítem de la lista de servicios es obligatorio y debe tener como máximo 5 caracteres. Ingrese un ítem de la LC 116 (3 o 4 dígitos) o de la Tabla de Servicios de la Ordenanza SF Nº 72/2006 de São Paulo (5 dígitos).',
            },
        ],
        technicalMessage: 'CodigoItemListaServico',
        severity: 'error',
        critical: false,
    },
    NFSE_WEBHOOK_ITEM_LIST_SERVICE_INVALID: {
        code: 'NFSE_WEBHOOK_ITEM_LIST_SERVICE_INVALID',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'O item da lista de serviços é obrigatório e deve ter no máximo 5 caracteres. Verifique o código LC116 nas configurações.',
            },
            {
                language: 'pt-BR',
                message: 'O item da lista de serviços é obrigatório e deve ter no máximo 5 caracteres. Verifique o código LC116 nas configurações.',
            },
            {
                language: 'en-US',
                message: 'The service list item is required and must have at most 5 characters. Please check the LC116 code in the settings.',
            },
            {
                language: 'es-ES',
                message: 'El ítem de la lista de servicios es obligatorio y debe tener como máximo 5 caracteres. Verifique el código LC116 en la configuración.',
            },
        ],
        technicalMessage: 'ItemListaServico',
        severity: 'error',
        critical: false,
    },
    NFSE_WEBHOOK_TOMADOR_CITY_DESCRIPTION_INVALID: {
        code: 'NFSE_WEBHOOK_TOMADOR_CITY_DESCRIPTION_INVALID',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'A cidade do tomador é obrigatória e deve ter no máximo 40 caracteres. Verifique o endereço do cliente.',
            },
            {
                language: 'pt-BR',
                message: 'A cidade do tomador é obrigatória e deve ter no máximo 40 caracteres. Verifique o endereço do cliente.',
            },
            {
                language: 'en-US',
                message: 'The recipient city is required and must have at most 40 characters. Please check the customer address.',
            },
            {
                language: 'es-ES',
                message: 'La ciudad del tomador es obligatoria y debe tener como máximo 40 caracteres. Verifique la dirección del cliente.',
            },
        ],
        technicalMessage: 'DescricaoCidadeTomador',
        severity: 'error',
        critical: false,
    },
    NFSE_WEBHOOK_TOMADOR_NEIGHBORHOOD_TOO_LONG: {
        code: 'NFSE_WEBHOOK_TOMADOR_NEIGHBORHOOD_TOO_LONG',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'O bairro do tomador deve ter no máximo 30 caracteres. Reduza o nome do bairro no endereço do cliente.',
            },
            {
                language: 'pt-BR',
                message: 'O bairro do tomador deve ter no máximo 30 caracteres. Reduza o nome do bairro no endereço do cliente.',
            },
            {
                language: 'en-US',
                message: 'The recipient neighborhood must have at most 30 characters. Shorten the neighborhood name in the customer address.',
            },
            {
                language: 'es-ES',
                message: 'El barrio del tomador debe tener como máximo 30 caracteres. Acorte el nombre del barrio en la dirección del cliente.',
            },
        ],
        technicalMessage: 'BairroTomador',
        severity: 'error',
        critical: false,
    },
};
